import { Form, Select } from "antd";
import { NamePath } from "antd/es/form/interface";
import * as React from "react";
import { ZAttrType } from "src/business/attribute";

type PropsSelectComponent<TComp> = {
  path: NamePath;
  dict: Record<ZAttrType, TComp[]>;
  value?: string;
  onChange?(value?: string): void;
};

export const SelectComponent = <TComp,>(props: PropsSelectComponent<TComp>) => {
  const { path, dict, value, onChange } = props;
  const tPath = [...path, "type"];
  const attrPath = [...path.slice(0, -2), "type", "name"];
  const attrType = Form.useWatch<ZAttrType>(attrPath);
  const form = Form.useFormInstance();
  const list = dict[attrType] ?? [];
  // Пришлось отслеживать предыдущее значение. Без него срабатывало условие для сброса при первом показе.
  const [prev, setPrev] = React.useState<string | undefined>();
  React.useEffect(() => {
    // Если происходит изменение типа, то вероятно что выбранный компонент не подойдёт и его нужно сбросить
    const curComp = form.getFieldValue(tPath);
    if (curComp && attrType !== prev) {
      const inList = list.includes(curComp);
      if (!inList) {
        form.resetFields([tPath]);
      }
    }
    setPrev(attrType);
  }, [attrType]);
  return (
    <Select
      options={list.map((it) => ({ value: it, label: it }))}
      allowClear
      title={tPath.join(".")}
      value={value}
      onChange={onChange}
    />
  );
};
